import React from 'react';

// Reusable input component
const InputField = ({ name, type, placeholder, value, onChange }) => (
  <input
    type={type}
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    className='border border-gray-600 px-4 py-3 w-full rounded-md'
  />
);

function ContractForm({ formData, handleChange }) {
  return (
    <div className='container mx-auto px-4 border border-gray-400 rounded-md shadow-lg'>
      <form className="my-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputField
          type="text"
          name="contractNumber"
          placeholder="Contract Number"
          value={formData.contractNumber}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="serviceProviderName"
          placeholder="Service Provider Name"
          value={formData.serviceProviderName}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="serviceProviderAddress"
          placeholder="Service Provider Address"
          value={formData.serviceProviderAddress}
          onChange={handleChange}
        />
        <InputField
          type="email"
          name="serviceProviderEmail"
          placeholder="Service Provider Email"
          value={formData.serviceProviderEmail}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="customerName"
          placeholder="Customer Name"
          value={formData.customerName}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="customerAddress"
          placeholder="Customer Address"
          value={formData.customerAddress}
          onChange={handleChange}
        />
        <InputField
          type="email"
          name="customerEmail"
          placeholder="Customer Email"
          value={formData.customerEmail}
          onChange={handleChange}
        />
        <InputField
          type="date"
          name="effectiveDate"
          placeholder="Effective Date"
          value={formData.effectiveDate}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="totalAmount"
          placeholder="Total Amount"
          value={formData.totalAmount}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="serviceProviderRepresentativeName"
          placeholder="Service Provider Rep. Name"
          value={formData.serviceProviderRepresentativeName}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="serviceProviderRepresentativeTitle"
          placeholder="Service Provider Rep. Title"
          value={formData.serviceProviderRepresentativeTitle}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="customerRepresentativeName"
          placeholder="Customer Rep. Name"
          value={formData.customerRepresentativeName}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="customerRepresentativeTitle"
          placeholder="Customer Rep. Title"
          value={formData.customerRepresentativeTitle}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="serviceProviderOfficeAddress"
          placeholder="Service Provider Office Address"
          value={formData.serviceProviderOfficeAddress}
          onChange={handleChange}
        />
        <InputField
          type="text"
          name="customerOfficeAddress"
          placeholder="Customer Office Address"
          value={formData.customerOfficeAddress}
          onChange={handleChange}
        />
      </form>
    </div>
  );
}

export default ContractForm;
